module.exports = __webpack_public_path__ + "img/make-brushes-1_en.d1374eb.jpg";